// extracted by mini-css-extract-plugin
module.exports = {"spacing2":"styles_spacing2__3X3X7","grid1":"styles_grid1__3_ArH","vehicle-type-container":"styles_vehicle-type-container__30qxb"};